import { render, staticRenderFns } from "./LaasonModal.vue?vue&type=template&id=87c01312&scoped=true&"
import script from "./LaasonModal.vue?vue&type=script&lang=js&"
export * from "./LaasonModal.vue?vue&type=script&lang=js&"
import style0 from "./LaasonModal.vue?vue&type=style&index=0&id=87c01312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c01312",
  null
  
)

export default component.exports